import { initializeStrapiBackend } from '../Contentful_API/strapiBackend';

const facet = 'sys.contentType.sys.id';

// Keep InstantSearch's UI while sending only public, bounded searches to Strapi.
export function createStrapiSearchClient(onError = () => {}) {
  return {
    async search(requests) {
      const { apiUrl } = await initializeStrapiBackend();
      try {
        const results = await Promise.all(requests.map(async ({ indexName, params = {} }) => {
          const types = (params.facetFilters || []).flat().filter(value => value.startsWith(`${facet}:`))
            .map(value => value.slice(facet.length + 1));
          const query = params.query || '';
          const page = params.page || 0;
          const hitsPerPage = params.hitsPerPage || 20;
          const search = new URLSearchParams({ q: query, page: String(page), pageSize: String(hitsPerPage), types: types.join(',') });
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 15000);
          let data;
          try {
            const response = await fetch(`${apiUrl}/search?${search}`, { signal: controller.signal, credentials: 'omit' });
            if (!response.ok) throw new Error('Search is temporarily unavailable. Please try again shortly.');
            data = await response.json();
          } finally { clearTimeout(timeout); }
          return {
            hits: data.hits.map(hit => ({ ...hit, objectID: hit.id })),
            nbHits: data.totalHits, nbPages: data.totalPages, page, hitsPerPage,
            processingTimeMS: data.processingTimeMs, query, params: search.toString(),
            index: indexName, facets: data.facetDistribution || {}, exhaustiveNbHits: true,
          };
        }));
        onError('');
        return { results };
      } catch (error) {
        onError('Search is temporarily unavailable. Please try again shortly.');
        throw error;
      }
    },
  };
}
